'use strict';

// This is an auto-generated file. Please do not edit directly.
// For instructions on editing source .json files, please see:
// https://git.hubteam.com/HubSpot/UIComponents/tree/master/HubStyleTokens
// ***********************************************************************

'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var PANEL_NAVIGATOR_TRANSITION_TIMING = exports.PANEL_NAVIGATOR_TRANSITION_TIMING = '400ms';
var CARD_TRANSITION_ANIMATION_TIMING = exports.CARD_TRANSITION_ANIMATION_TIMING = '200ms';
var ACCORDION_TRANSITION_ANIMATION_TIMING = exports.ACCORDION_TRANSITION_ANIMATION_TIMING = '200ms';
var TABS_ACTIVATE_TRANSITION_TIMING = exports.TABS_ACTIVATE_TRANSITION_TIMING = '200ms';
var NAV_LIST_TRANSITION_ANIMATION_TIMING = exports.NAV_LIST_TRANSITION_ANIMATION_TIMING = '200ms';
var MICRO_TRANSITION_TIMING = exports.MICRO_TRANSITION_TIMING = '150ms';
var EDITABLE_CONTROLS_TRANSITION_TIMING = exports.EDITABLE_CONTROLS_TRANSITION_TIMING = '250ms';
var DEFAULT_MODAL_TRANSITION_TIMING = exports.DEFAULT_MODAL_TRANSITION_TIMING = '350ms';
var SLIDEIN_MODAL_TRANSITION_TIMING = exports.SLIDEIN_MODAL_TRANSITION_TIMING = '300ms';
var PANEL_TRANSITION_TIMING = exports.PANEL_TRANSITION_TIMING = '150ms';
var MODAL_BACKGROUND_TRANSITION_TIMING = exports.MODAL_BACKGROUND_TRANSITION_TIMING = '100ms';
var HOVERLAY_TRANSITION_TIMING = exports.HOVERLAY_TRANSITION_TIMING = '200ms';
var FLOATING_ALERT_TIMING = exports.FLOATING_ALERT_TIMING = '300ms';
var POPOVER_TRANSITION_TIMING = exports.POPOVER_TRANSITION_TIMING = '200ms';
var NOTIFICATION_BADGE_APPEAR_ANIMATION_TIMING = exports.NOTIFICATION_BADGE_APPEAR_ANIMATION_TIMING = '300ms';
var NOTIFICATION_BADGE_ENTER_ANIMATION_TIMING = exports.NOTIFICATION_BADGE_ENTER_ANIMATION_TIMING = '100ms';
var NOTIFICATION_BADGE_LEAVE_ANIMATION_TIMING = exports.NOTIFICATION_BADGE_LEAVE_ANIMATION_TIMING = '150ms';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/HubStyleTokens/static-2.487/js/times.js
// module id = 286
// module chunks = 2 3